import { useMutation, useQueryClient } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { getUsePartiesQKey } from '../../overview/api/getParties';
import { Party } from '../../../types';
import { getUsePartyQKey } from './getParty';

interface PatchParams {
  partyId: string;
  payload: Partial<Party>;
}

export const patchPartyById = async ({ partyId, payload }: PatchParams) => {
  const path = `v1/api/parties/${partyId}`;
  const { data, isError } = await wgApi.patch(path, payload);
  if (isError) throw new Error();
  return data;
};

export const usePatchParty = () => {
  const queryClient = useQueryClient();
  return useMutation(patchPartyById, {
    onMutate: async ({ partyId, payload }) => {
      const queryKey = getUsePartyQKey(partyId);
      await queryClient.cancelQueries(queryKey);

      const prevData = queryClient.getQueryData<Party>(queryKey);

      queryClient.setQueryData(queryKey, {
        ...prevData,
        ...payload,
      });

      return prevData;
    },
    onError: (_, { partyId }, context) => {
      const queryKey = getUsePartyQKey(partyId);
      if (context) queryClient.setQueryData(queryKey, context);
    },
    onSettled: (_, __, { partyId }) => {
      const queryKey = getUsePartyQKey(partyId);
      const partiesQkey = getUsePartiesQKey();
      queryClient.invalidateQueries(queryKey);
      queryClient.invalidateQueries(partiesQkey);
    },
  });
};
